import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { from, map } from 'rxjs';
import { MatrixService } from '../../services/matrix/matrix.service';

export const keybackupGuard: CanActivateFn = () => {
  const matrix = inject(MatrixService);
  const router = inject(Router);
  const item = sessionStorage.getItem('keybackupinteraction');
  if (matrix.hasClient && !item) {
    return true;
  }
  return from(matrix.restoreSession('')).pipe(map(success => (success ? router.parseUrl('/rooms') : true)));
};
